<template>
  <div>
    <div
      v-for="(value, key) in props"
      :key="key"
      :id="`item-${key}`"
      @click="setCurrentLayer(value)"
    >
      <component
        :is="value.name"
        v-bind="value.props"
        @change="change"
        @upload="upload"
      >
      </component>
      <el-divider></el-divider>
    </div>
  </div>
</template>

<script>
import TextItem from './TextItem.vue'
import ColorItem from './ColorItem.vue'
import ImageItem from './ImageItem.vue'
import RadioItem from './RadioItem.vue'
import SelectItem from './SelectItem.vue'

export default {
  props: {
    props: {
      type: Array,
      required: true
    }
  },
  components: {
    TextItem,
    ColorItem,
    ImageItem,
    RadioItem,
    SelectItem
  },
  data () {
    return {
    }
  },
  methods: {
    change (e) {
      this.$emit('change', e)
    },
    upload (e) {
      this.$emit('upload', e)
    },
    setCurrentLayer (e) {
      this.$store.commit('setCurrentLayer', e)
    },
    focus (id) {
      this.$store.commit('focus', id)
    },
    loseFocus (id) {
      this.$store.commit('loseFocus', id)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.el-form-item__label {
  font-weight: bold;
  width: 50% !important;
  text-align: left;
}
.el-form-item__content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.el-form-item {
  margin-bottom: 10px;
}
.el-divider--horizontal {
  margin: 0;
}
.download {
  margin-top: 20px;
}
.el-color-picker__icon {
  display: none;
}
</style>
